import APICall from "../utils/APICall"

export class ComplaintServices{
    static listComplaints = async () => {
        return await APICall("/api/ComplaintService/admin/list-customer-tickets","GET")
    }
    static getTicketDetails = async (ticketId) => {
        return await APICall(`/api/ComplaintService/admin/get-ticket-details?ticketId=${ticketId}`, "GET");
    }
    static listConversations = async (ticketId) => {
        return await APICall(`/api/ComplaintService/admin/list-conversations?ticketId=${ticketId}`,"GET")
    }
    static addConversation = async (payload) => {
        return await APICall("/api/ComplaintService/admin/add-conversations","POST", payload);
    }
}